import React, { FC } from 'react';
import { Box, Button, makeStyles } from '@dxb-web-ui-framework/design-system';
import clsx from 'clsx';

type makeStylesProps = {
  isFullWidth: boolean;
  customWidth?: number;
};

const useStyles = ({ isFullWidth, customWidth }: makeStylesProps) =>
  makeStyles(theme => ({
    buttonWrapper: {
      width: isFullWidth ? '49%' : '100%',
      flex: isFullWidth ? 0.5 : 1,
      maxWidth: isFullWidth ? '100%' : customWidth ? theme.spacing(customWidth) : theme.spacing(17),
      [theme.breakpoints.down('sm')]: {
        maxWidth: 'none',
      },
    },
  }));

type MatchButtonsProps = {
  isFullWidth: boolean;
  customWidth?: number;
  leftBtnCustomClass?: string;
  leftBtnFullWidth: boolean;
  isLeftBtnDisabled?: boolean;
  onClickLeftBtn: (() => void) | ((e: any) => void) | undefined;
  leftBtnTitle?: string;
  leftBtnLabel: string;
  leftBtnHasSkeleton?: boolean;
  leftBtnDataTestId?: string;
  rightBtnCustomClass?: string;
  rightBtnFullWidth: boolean;
  isRightBtnDisabled?: boolean;
  onClickRightBtn?: (() => void) | ((e: any) => void) | undefined;
  rightBtnTitle?: string;
  rightBtnLabel: string;
  rightBtnHasSkeleton?: boolean;
  rightBtnDataTestId?: string;
};

const MatchButtons: FC<MatchButtonsProps> = ({
  isFullWidth,
  customWidth,
  leftBtnCustomClass,
  leftBtnFullWidth,
  isLeftBtnDisabled,
  onClickLeftBtn,
  leftBtnTitle,
  leftBtnLabel,
  leftBtnHasSkeleton,
  leftBtnDataTestId,
  rightBtnCustomClass,
  rightBtnFullWidth,
  isRightBtnDisabled,
  onClickRightBtn,
  rightBtnTitle,
  rightBtnLabel,
  rightBtnHasSkeleton,
  rightBtnDataTestId,
}) => {
  const styles = useStyles({ isFullWidth, customWidth })();

  return (
    <>
      <Box mr={2} className={clsx(styles.buttonWrapper, leftBtnCustomClass)}>
        <Button
          fullWidth={leftBtnFullWidth}
          color='primary'
          size='large'
          title={leftBtnTitle}
          disabled={isLeftBtnDisabled}
          variant='outlined'
          onClick={onClickLeftBtn}
          hasSkeleton={leftBtnHasSkeleton}
          data-testid={leftBtnDataTestId}>
          {leftBtnLabel}
        </Button>
      </Box>
      <Box className={clsx(styles.buttonWrapper, rightBtnCustomClass)}>
        <Button
          fullWidth={rightBtnFullWidth}
          type={Boolean(onClickRightBtn) ? 'button' : 'submit'}
          color='primary'
          disabled={isRightBtnDisabled}
          size='large'
          title={rightBtnTitle}
          variant='contained'
          onClick={onClickRightBtn}
          hasSkeleton={rightBtnHasSkeleton}
          data-testid={rightBtnDataTestId}>
          {rightBtnLabel}
        </Button>
      </Box>
    </>
  );
};

export { MatchButtons };
